import { render, staticRenderFns } from "./footer-stripped.vue?vue&type=template&id=ab402714&"
import script from "./footer-stripped.vue?vue&type=script&lang=js&"
export * from "./footer-stripped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports